const MATRIX_VIA = ["fediverse.ooo", "aftermath.gg", "matrix.org"]
  .map((via) => "via=" + via)
  .join("&");
export const DISCORD_INVITE = "https://discord.gg/XrDSJ2WJqa";
export const MATRIX_ALIAS = "#canvas:fediverse.ooo";
export const MATRIX_INVITE = `https://matrix.to/#/${MATRIX_ALIAS}?${MATRIX_VIA}`;
/**
 * MSC2312
 * @see https://github.com/matrix-org/matrix-spec-proposals/blob/main/proposals/2312-matrix-uri.md
 */
export const MATRIX_URL = `matrix:r/${MATRIX_ALIAS.slice(1)}?${MATRIX_VIA}`;
